module.exports = __webpack_public_path__ + "img/4_uk.eafdb2fd.svg";